import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function pageCardTemplate(item) {
  return html`
    <a href="/pages/${item.handle}" class="ac-page-card">
      ${item.title}
    </a>
  `;
}